import { render, staticRenderFns } from "./MRSignature.vue?vue&type=template&id=c09f83ae"
import script from "./MRSignature.vue?vue&type=script&lang=ts"
export * from "./MRSignature.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports